<template>
    <table class="table table-responsive-md border border-gray">
        <thead>
            <tr class="bg-table-header">
                <th>First Name</th>
                <th>Last Name</th>
                <th>Role</th>
                <th>Relationship</th>
                <th>Primary Phone</th>
                <th class="text-center">Emergency Contact</th>
                <th class="text-center">CAHPS Survey</th>
                <th class="text-center">Bereavement Contact</th>
                <th class="text-end">Actions</th>
            </tr>
        </thead>
        <tbody v-if="isLoading || isError || !hasData">
            <!-- LOADING -->
            <tr v-for="i of loadingCount" class="table-loading" v-if="isLoading">
                <td v-for="i of columns">
                    <span class="shimmer-loading"></span>
                </td>
            </tr>
            <!-- EMPTY -->
            <tr class="table-empty" v-if="!isLoading && !isError && !hasData">
                <td :colspan="columns">
                    <h3>No Contacts Found.</h3>
                </td>
            </tr>
            <!-- ERROR -->
            <tr class="table-error" v-if="!isLoading && isError">
                <td :colspan="columns">
                    <ErrorMessageHandler title="Contact list" :try-again="getAuthorizedContacts" />
                </td>
            </tr>
        </tbody>
        <template v-else>
            <AuthorizedContactRow
                v-for="(contact, index) in contacts"
                :key="contact?.id"
                :contact="contact"
                :index="index"
                :is-re-order-requested="isReOrderRequested"
                :patient-primary-address="patientPrimaryAddress"
                :columns="columns"
                :patient-id="patientId"
                :total-contacts="totalContacts"
                :cahps-survey-recipient-index="cahpsSurveyRecipientIndex"
                :relationships-enum="relationshipsEnum"
                :contact-roles-enum="contactRolesEnum"
                :cahps-survey-contact-enum="cahpsSurveyContactEnum"
                :refresh-list="getAuthorizedContacts"
                :move-up="moveUp"
                :move-down="moveDown"
                :update-contact="updateAuthorizedContact"
                :delete-authorized-contact="deleteAuthorizedContact"
            />
        </template>
    </table>
</template>

<script lang="ts" src="./AuthorizedContactList.ts"></script>
